// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AnalyseRouteImport } from './routes/analyse'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BeveiligingRouteImport } from './routes/beveiliging'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DienstenRouteImport } from './routes/diensten'
import { Route as EmailPreviewRouteImport } from './routes/email-preview'
import { Route as ExpertiseRouteImport } from './routes/expertise'
import { Route as LogoPreviewRouteImport } from './routes/logo-preview'
import { Route as MethodeRouteImport } from './routes/methode'
import { Route as OgPreviewRouteImport } from './routes/og-preview'
import { Route as OverOnsRouteImport } from './routes/over-ons'
import { Route as PakkettenRouteImport } from './routes/pakketten'
import { Route as PrijskaartRouteImport } from './routes/prijskaart'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProcesRouteImport } from './routes/proces'
import { Route as RapportRouteImport } from './routes/rapport'
import { Route as RealisatiesRouteImport } from './routes/realisaties'
import { Route as SecondOpinionRouteImport } from './routes/second-opinion'
import { Route as TechnologieRouteImport } from './routes/technologie'
import { Route as VoorBureausRouteImport } from './routes/voor-bureaus'
import { Route as VoorbeeldenRouteImport } from './routes/voorbeelden'
import { Route as LangIndexRouteImport } from './routes/$lang.index'
import { Route as LangAProposRouteImport } from './routes/$lang.a-propos'
import { Route as LangAboutRouteImport } from './routes/$lang.about'
import { Route as LangAnalyseRouteImport } from './routes/$lang.analyse'
import { Route as LangAnalysisRouteImport } from './routes/$lang.analysis'
import { Route as LangAuditRouteImport } from './routes/$lang.audit'
import { Route as LangAvisIndependantRouteImport } from './routes/$lang.avis-independant'
import { Route as LangConfidentialiteRouteImport } from './routes/$lang.confidentialite'
import { Route as LangContactRouteImport } from './routes/$lang.contact'
import { Route as LangExamplesRouteImport } from './routes/$lang.examples'
import { Route as LangExemplesRouteImport } from './routes/$lang.exemples'
import { Route as LangExpertiseRouteImport } from './routes/$lang.expertise'
import { Route as LangForAgenciesRouteImport } from './routes/$lang.for-agencies'
import { Route as LangForfaitsRouteImport } from './routes/$lang.forfaits'
import { Route as LangIndependentReviewRouteImport } from './routes/$lang.independent-review'
import { Route as LangMethodRouteImport } from './routes/$lang.method'
import { Route as LangMethodeRouteImport } from './routes/$lang.methode'
import { Route as LangPackagesRouteImport } from './routes/$lang.packages'
import { Route as LangPourAgencesRouteImport } from './routes/$lang.pour-agences'
import { Route as LangPricingSheetRouteImport } from './routes/$lang.pricing-sheet'
import { Route as LangPrivacyRouteImport } from './routes/$lang.privacy'
import { Route as LangProcessRouteImport } from './routes/$lang.process'
import { Route as LangProcessusRouteImport } from './routes/$lang.processus'
import { Route as LangProjectsRouteImport } from './routes/$lang.projects'
import { Route as LangRapportExempleRouteImport } from './routes/$lang.rapport-exemple'
import { Route as LangRealisationsRouteImport } from './routes/$lang.realisations'
import { Route as LangSampleReportRouteImport } from './routes/$lang.sample-report'
import { Route as LangSecuriteRouteImport } from './routes/$lang.securite'
import { Route as LangSecurityRouteImport } from './routes/$lang.security'
import { Route as LangServicesRouteImport } from './routes/$lang.services'
import { Route as LangTarifsRouteImport } from './routes/$lang.tarifs'
import { Route as LangTechnologieRouteImport } from './routes/$lang.technologie'
import { Route as LangTechnologyRouteImport } from './routes/$lang.technology'
import { Route as BlogWatKostEenWebsiteLatenMakenRouteImport } from './routes/blog.wat-kost-een-website-laten-maken'
import { Route as ShowcaseHomepageRouteImport } from './routes/showcase.homepage'
import { Route as ShowcaseHomepage2RouteImport } from './routes/showcase.homepage-2'
import { Route as WoordenlijstIndexRouteImport } from './routes/woordenlijst.index'
import { Route as WoordenlijstTermRouteImport } from './routes/woordenlijst.$term'
import { Route as LangBlogPrixSiteWebRouteImport } from './routes/$lang.blog.prix-site-web'
import { Route as LangBlogWebsiteCostRouteImport } from './routes/$lang.blog.website-cost'
import { Route as LangGlossaireIndexRouteImport } from './routes/$lang.glossaire.index'
import { Route as LangGlossaireTermRouteImport } from './routes/$lang.glossaire.$term'
import { Route as LangGlossaryIndexRouteImport } from './routes/$lang.glossary.index'
import { Route as LangGlossaryTermRouteImport } from './routes/$lang.glossary.$term'
import { Route as AuthenticatedAdminFunnelRouteImport } from './routes/_authenticated/admin.funnel'
import { Route as AuthenticatedAdminI18nRouteImport } from './routes/_authenticated/admin.i18n'
import { Route as AuthenticatedAdminLeadsRouteImport } from './routes/_authenticated/admin.leads'
import { Route as AuthenticatedAdminPagespeedRouteImport } from './routes/_authenticated/admin.pagespeed'
import { Route as AuthenticatedAdminTemplatesRouteImport } from './routes/_authenticated/admin.templates'
import { Route as AuthenticatedAdminVitalsRouteImport } from './routes/_authenticated/admin.vitals'
import { Route as AuthenticatedAdminLeadsLeadIdRouteImport } from './routes/_authenticated/admin.leads_.$leadId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AnalyseRoute = AnalyseRouteImport.update({
            id: '/analyse',path: '/analyse',getParentRoute: () => rootRouteImport
          })
const AuditRoute = AuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BeveiligingRoute = BeveiligingRouteImport.update({
            id: '/beveiliging',path: '/beveiliging',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DienstenRoute = DienstenRouteImport.update({
            id: '/diensten',path: '/diensten',getParentRoute: () => rootRouteImport
          })
const EmailPreviewRoute = EmailPreviewRouteImport.update({
            id: '/email-preview',path: '/email-preview',getParentRoute: () => rootRouteImport
          })
const ExpertiseRoute = ExpertiseRouteImport.update({
            id: '/expertise',path: '/expertise',getParentRoute: () => rootRouteImport
          })
const LogoPreviewRoute = LogoPreviewRouteImport.update({
            id: '/logo-preview',path: '/logo-preview',getParentRoute: () => rootRouteImport
          })
const MethodeRoute = MethodeRouteImport.update({
            id: '/methode',path: '/methode',getParentRoute: () => rootRouteImport
          })
const OgPreviewRoute = OgPreviewRouteImport.update({
            id: '/og-preview',path: '/og-preview',getParentRoute: () => rootRouteImport
          })
const OverOnsRoute = OverOnsRouteImport.update({
            id: '/over-ons',path: '/over-ons',getParentRoute: () => rootRouteImport
          })
const PakkettenRoute = PakkettenRouteImport.update({
            id: '/pakketten',path: '/pakketten',getParentRoute: () => rootRouteImport
          })
const PrijskaartRoute = PrijskaartRouteImport.update({
            id: '/prijskaart',path: '/prijskaart',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProcesRoute = ProcesRouteImport.update({
            id: '/proces',path: '/proces',getParentRoute: () => rootRouteImport
          })
const RapportRoute = RapportRouteImport.update({
            id: '/rapport',path: '/rapport',getParentRoute: () => rootRouteImport
          })
const RealisatiesRoute = RealisatiesRouteImport.update({
            id: '/realisaties',path: '/realisaties',getParentRoute: () => rootRouteImport
          })
const SecondOpinionRoute = SecondOpinionRouteImport.update({
            id: '/second-opinion',path: '/second-opinion',getParentRoute: () => rootRouteImport
          })
const TechnologieRoute = TechnologieRouteImport.update({
            id: '/technologie',path: '/technologie',getParentRoute: () => rootRouteImport
          })
const VoorBureausRoute = VoorBureausRouteImport.update({
            id: '/voor-bureaus',path: '/voor-bureaus',getParentRoute: () => rootRouteImport
          })
const VoorbeeldenRoute = VoorbeeldenRouteImport.update({
            id: '/voorbeelden',path: '/voorbeelden',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangRoute
          })
const LangAProposRoute = LangAProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => LangRoute
          })
const LangAboutRoute = LangAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LangRoute
          })
const LangAnalyseRoute = LangAnalyseRouteImport.update({
            id: '/analyse',path: '/analyse',getParentRoute: () => LangRoute
          })
const LangAnalysisRoute = LangAnalysisRouteImport.update({
            id: '/analysis',path: '/analysis',getParentRoute: () => LangRoute
          })
const LangAuditRoute = LangAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => LangRoute
          })
const LangAvisIndependantRoute = LangAvisIndependantRouteImport.update({
            id: '/avis-independant',path: '/avis-independant',getParentRoute: () => LangRoute
          })
const LangConfidentialiteRoute = LangConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => LangRoute
          })
const LangContactRoute = LangContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LangRoute
          })
const LangExamplesRoute = LangExamplesRouteImport.update({
            id: '/examples',path: '/examples',getParentRoute: () => LangRoute
          })
const LangExemplesRoute = LangExemplesRouteImport.update({
            id: '/exemples',path: '/exemples',getParentRoute: () => LangRoute
          })
const LangExpertiseRoute = LangExpertiseRouteImport.update({
            id: '/expertise',path: '/expertise',getParentRoute: () => LangRoute
          })
const LangForAgenciesRoute = LangForAgenciesRouteImport.update({
            id: '/for-agencies',path: '/for-agencies',getParentRoute: () => LangRoute
          })
const LangForfaitsRoute = LangForfaitsRouteImport.update({
            id: '/forfaits',path: '/forfaits',getParentRoute: () => LangRoute
          })
const LangIndependentReviewRoute = LangIndependentReviewRouteImport.update({
            id: '/independent-review',path: '/independent-review',getParentRoute: () => LangRoute
          })
const LangMethodRoute = LangMethodRouteImport.update({
            id: '/method',path: '/method',getParentRoute: () => LangRoute
          })
const LangMethodeRoute = LangMethodeRouteImport.update({
            id: '/methode',path: '/methode',getParentRoute: () => LangRoute
          })
const LangPackagesRoute = LangPackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => LangRoute
          })
const LangPourAgencesRoute = LangPourAgencesRouteImport.update({
            id: '/pour-agences',path: '/pour-agences',getParentRoute: () => LangRoute
          })
const LangPricingSheetRoute = LangPricingSheetRouteImport.update({
            id: '/pricing-sheet',path: '/pricing-sheet',getParentRoute: () => LangRoute
          })
const LangPrivacyRoute = LangPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LangRoute
          })
const LangProcessRoute = LangProcessRouteImport.update({
            id: '/process',path: '/process',getParentRoute: () => LangRoute
          })
const LangProcessusRoute = LangProcessusRouteImport.update({
            id: '/processus',path: '/processus',getParentRoute: () => LangRoute
          })
const LangProjectsRoute = LangProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => LangRoute
          })
const LangRapportExempleRoute = LangRapportExempleRouteImport.update({
            id: '/rapport-exemple',path: '/rapport-exemple',getParentRoute: () => LangRoute
          })
const LangRealisationsRoute = LangRealisationsRouteImport.update({
            id: '/realisations',path: '/realisations',getParentRoute: () => LangRoute
          })
const LangSampleReportRoute = LangSampleReportRouteImport.update({
            id: '/sample-report',path: '/sample-report',getParentRoute: () => LangRoute
          })
const LangSecuriteRoute = LangSecuriteRouteImport.update({
            id: '/securite',path: '/securite',getParentRoute: () => LangRoute
          })
const LangSecurityRoute = LangSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => LangRoute
          })
const LangServicesRoute = LangServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => LangRoute
          })
const LangTarifsRoute = LangTarifsRouteImport.update({
            id: '/tarifs',path: '/tarifs',getParentRoute: () => LangRoute
          })
const LangTechnologieRoute = LangTechnologieRouteImport.update({
            id: '/technologie',path: '/technologie',getParentRoute: () => LangRoute
          })
const LangTechnologyRoute = LangTechnologyRouteImport.update({
            id: '/technology',path: '/technology',getParentRoute: () => LangRoute
          })
const BlogWatKostEenWebsiteLatenMakenRoute = BlogWatKostEenWebsiteLatenMakenRouteImport.update({
            id: '/blog/wat-kost-een-website-laten-maken',path: '/blog/wat-kost-een-website-laten-maken',getParentRoute: () => rootRouteImport
          })
const ShowcaseHomepageRoute = ShowcaseHomepageRouteImport.update({
            id: '/showcase/homepage',path: '/showcase/homepage',getParentRoute: () => rootRouteImport
          })
const ShowcaseHomepage2Route = ShowcaseHomepage2RouteImport.update({
            id: '/showcase/homepage-2',path: '/showcase/homepage-2',getParentRoute: () => rootRouteImport
          })
const WoordenlijstIndexRoute = WoordenlijstIndexRouteImport.update({
            id: '/woordenlijst/',path: '/woordenlijst/',getParentRoute: () => rootRouteImport
          })
const WoordenlijstTermRoute = WoordenlijstTermRouteImport.update({
            id: '/woordenlijst/$term',path: '/woordenlijst/$term',getParentRoute: () => rootRouteImport
          })
const LangBlogPrixSiteWebRoute = LangBlogPrixSiteWebRouteImport.update({
            id: '/blog/prix-site-web',path: '/blog/prix-site-web',getParentRoute: () => LangRoute
          })
const LangBlogWebsiteCostRoute = LangBlogWebsiteCostRouteImport.update({
            id: '/blog/website-cost',path: '/blog/website-cost',getParentRoute: () => LangRoute
          })
const LangGlossaireIndexRoute = LangGlossaireIndexRouteImport.update({
            id: '/glossaire/',path: '/glossaire/',getParentRoute: () => LangRoute
          })
const LangGlossaireTermRoute = LangGlossaireTermRouteImport.update({
            id: '/glossaire/$term',path: '/glossaire/$term',getParentRoute: () => LangRoute
          })
const LangGlossaryIndexRoute = LangGlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => LangRoute
          })
const LangGlossaryTermRoute = LangGlossaryTermRouteImport.update({
            id: '/glossary/$term',path: '/glossary/$term',getParentRoute: () => LangRoute
          })
const AuthenticatedAdminFunnelRoute = AuthenticatedAdminFunnelRouteImport.update({
            id: '/admin/funnel',path: '/admin/funnel',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminI18nRoute = AuthenticatedAdminI18nRouteImport.update({
            id: '/admin/i18n',path: '/admin/i18n',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminLeadsRoute = AuthenticatedAdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminPagespeedRoute = AuthenticatedAdminPagespeedRouteImport.update({
            id: '/admin/pagespeed',path: '/admin/pagespeed',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTemplatesRoute = AuthenticatedAdminTemplatesRouteImport.update({
            id: '/admin/templates',path: '/admin/templates',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminVitalsRoute = AuthenticatedAdminVitalsRouteImport.update({
            id: '/admin/vitals',path: '/admin/vitals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminLeadsLeadIdRoute = AuthenticatedAdminLeadsLeadIdRouteImport.update({
            id: '/admin/leads_/$leadId',path: '/admin/leads/$leadId',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminFunnelRoute: AuthenticatedAdminFunnelRoute,AuthenticatedAdminI18nRoute: AuthenticatedAdminI18nRoute,AuthenticatedAdminLeadsRoute: AuthenticatedAdminLeadsRoute,AuthenticatedAdminPagespeedRoute: AuthenticatedAdminPagespeedRoute,AuthenticatedAdminTemplatesRoute: AuthenticatedAdminTemplatesRoute,AuthenticatedAdminVitalsRoute: AuthenticatedAdminVitalsRoute,AuthenticatedAdminLeadsLeadIdRoute: AuthenticatedAdminLeadsLeadIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const LangRouteChildren = {
  LangAProposRoute: LangAProposRoute,LangAboutRoute: LangAboutRoute,LangAnalyseRoute: LangAnalyseRoute,LangAnalysisRoute: LangAnalysisRoute,LangAuditRoute: LangAuditRoute,LangAvisIndependantRoute: LangAvisIndependantRoute,LangConfidentialiteRoute: LangConfidentialiteRoute,LangContactRoute: LangContactRoute,LangExamplesRoute: LangExamplesRoute,LangExemplesRoute: LangExemplesRoute,LangExpertiseRoute: LangExpertiseRoute,LangForAgenciesRoute: LangForAgenciesRoute,LangForfaitsRoute: LangForfaitsRoute,LangIndependentReviewRoute: LangIndependentReviewRoute,LangMethodRoute: LangMethodRoute,LangMethodeRoute: LangMethodeRoute,LangPackagesRoute: LangPackagesRoute,LangPourAgencesRoute: LangPourAgencesRoute,LangPricingSheetRoute: LangPricingSheetRoute,LangPrivacyRoute: LangPrivacyRoute,LangProcessRoute: LangProcessRoute,LangProcessusRoute: LangProcessusRoute,LangProjectsRoute: LangProjectsRoute,LangRapportExempleRoute: LangRapportExempleRoute,LangRealisationsRoute: LangRealisationsRoute,LangSampleReportRoute: LangSampleReportRoute,LangSecuriteRoute: LangSecuriteRoute,LangSecurityRoute: LangSecurityRoute,LangServicesRoute: LangServicesRoute,LangTarifsRoute: LangTarifsRoute,LangTechnologieRoute: LangTechnologieRoute,LangTechnologyRoute: LangTechnologyRoute,LangIndexRoute: LangIndexRoute,LangBlogPrixSiteWebRoute: LangBlogPrixSiteWebRoute,LangBlogWebsiteCostRoute: LangBlogWebsiteCostRoute,LangGlossaireTermRoute: LangGlossaireTermRoute,LangGlossaryTermRoute: LangGlossaryTermRoute,LangGlossaireIndexRoute: LangGlossaireIndexRoute,LangGlossaryIndexRoute: LangGlossaryIndexRoute
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,LangRoute: LangRouteWithChildren,AnalyseRoute: AnalyseRoute,AuditRoute: AuditRoute,AuthRoute: AuthRoute,BeveiligingRoute: BeveiligingRoute,ContactRoute: ContactRoute,DienstenRoute: DienstenRoute,EmailPreviewRoute: EmailPreviewRoute,ExpertiseRoute: ExpertiseRoute,LogoPreviewRoute: LogoPreviewRoute,MethodeRoute: MethodeRoute,OgPreviewRoute: OgPreviewRoute,OverOnsRoute: OverOnsRoute,PakkettenRoute: PakkettenRoute,PrijskaartRoute: PrijskaartRoute,PrivacyRoute: PrivacyRoute,ProcesRoute: ProcesRoute,RapportRoute: RapportRoute,RealisatiesRoute: RealisatiesRoute,SecondOpinionRoute: SecondOpinionRoute,TechnologieRoute: TechnologieRoute,VoorBureausRoute: VoorBureausRoute,VoorbeeldenRoute: VoorbeeldenRoute,BlogWatKostEenWebsiteLatenMakenRoute: BlogWatKostEenWebsiteLatenMakenRoute,ShowcaseHomepageRoute: ShowcaseHomepageRoute,ShowcaseHomepage2Route: ShowcaseHomepage2Route,WoordenlijstTermRoute: WoordenlijstTermRoute,WoordenlijstIndexRoute: WoordenlijstIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)